import { eventMinute, usedOpportunities, maxOpportunities } from "@/lib/events";
import { teamStyle } from "@/lib/colors";

export const subsSummary = (m, side) => {
  const subs = m.events.filter((e) => e.type === "substituicao" && e.team === side)
    .sort((a, b) => a.period - b.period || a.seconds - b.seconds);
  const groups = {};
  subs.forEach((e) => {
    const k = e.halftime ? "int" : e.opportunity || "—";
    (groups[k] ||= { opp: e.opportunity, halftime: !!e.halftime, minute: eventMinute(e, m.half2_reset), pairs: [] }).pairs.push(`${e.target} → ${e.player_in}`);
  });
  return { used: usedOpportunities(m, side).size, total: subs.length, groups: Object.values(groups) };
};

const TeamSubs = ({ match, side }) => {
  const s = subsSummary(match, side);
  return (
    <div data-testid={`subs-${side}`} className="border border-white/15 bg-[#131313]">
      <div style={teamStyle(match[side])} className="flex items-center justify-between gap-3 px-5 py-3">
        <h3 className="font-display text-2xl font-bold uppercase truncate">{match[side].name}</h3>
        <span data-testid={`subs-${side}-used`} className="font-display text-xl font-bold whitespace-nowrap">{s.used}/{maxOpportunities(match)} oportunidades</span>
      </div>
      <div className="px-5 py-4">
        <p className="text-sm text-zinc-400 mb-3">{s.total} {s.total === 1 ? "substituição" : "substituições"}</p>
        {s.groups.length ? (
          <ul className="space-y-2">
            {s.groups.map((g, i) => (
              <li key={i} className="flex flex-wrap items-center gap-2 text-sm">
                <span className="px-2 py-0.5 bg-white/10 font-semibold">{g.halftime ? "Intervalo (não conta)" : g.opp ? `Oportunidade ${g.opp}` : "Sem oportunidade"}</span>
                <span className="text-zinc-500">{g.minute}</span>
                <span className="text-zinc-200">{g.pairs.join(" · ")}</span>
              </li>
            ))}
          </ul>
        ) : <p className="text-sm text-zinc-600">—</p>}
      </div>
    </div>
  );
};

export const SubsByTeam = ({ match }) => (
  <div className="grid md:grid-cols-2 gap-6">
    <TeamSubs match={match} side="home" />
    <TeamSubs match={match} side="away" />
  </div>
);
